import React from "react";
import { Form, Input, Button } from "antd";

function DynamicList({ name, label, placeholder }) {
  return (
    <Form.Item label={label}>
      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, ...field }) => (
              <div
                key={key}
                style={{ display: "flex", gap: 8, marginBottom: 8 }}
              >
                <Form.Item {...field} noStyle>
                  <Input placeholder={placeholder} style={{ flex: 1 }} />
                </Form.Item>
                <Button danger onClick={() => remove(field.name)}>
                  —
                </Button>
              </div>
            ))}
            <Button type="dashed" onClick={() => add()} block>
              + Нэмэх
            </Button>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
}

export default function CompareSection() {
  return (
    <>
      <DynamicList
        name="coverageRisks"
        label="Хамгаалах эрсдэл"
        placeholder="Жишээ: Гал түймэр, дэлбэрэлт"
      />
      <DynamicList
        name="ownLiability"
        label="Даатгуулагчийн өөрийн хүлээх хариуцлага"
        placeholder="Жишээ: Стандарт нөхцөлд хэмжээ"
      />
      <DynamicList
        name="claimConditions"
        label="Нөхөн төлбөрийн нөхцөл"
        placeholder="Жишээ: Зах зээлийн үнээр үнэлгээ тогтооно"
      />
      <DynamicList
        name="additionalConditions"
        label="Нэмэлт нөхцөл"
        placeholder="Жишээ: Нэхэн төлбөрийн нөхцөл"
      />

      <Form.Item name="geographicScope" label="Газар нутгийн хязгаар">
        <Input placeholder="Монгол Улс" />
      </Form.Item>
    </>
  );
}
